export default "__VITE_ASSET__mT3yko3e__"